<template>
  <div class="page-content">
    <div class="content-container">
      <div class="content-heading">
        <div class="content-heading__slot">
          <slot name="content-heading"></slot>
        </div>
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  data() {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import "nib"

.page-content
  column()
  align-items center
  width 100%
  flex-grow 1
  box-sizing border-box

.heading-container
  row()
  notSelectable()
  min-height 180px
  relative top left
  box-sizing border-box
  width 100%
  background #ebebeb
  margin-bottom 15px

.content-container
  box-sizing border-box
  width 100%
  background #EBEFF2
  overflow hidden

.content
  column()
  width 100%
  flex-grow 1
  box-sizing border-box
  // min-height 100vh
  relative top left
  border-top 1px solid rgba(0, 0, 0, 0.16)

.content-heading
  row()
  width 100%
  align-items center
  justify-content center
  background #D8E0E4
  &__slot
    row()
    justify-content center
    width 1200px
    max-width 100%
    margin auto

</style>



// WEBPACK FOOTER //
// src/components/abstract/PageContent.vue